import "../css/BannièreHaut.css";

export default function TopBanner({afficherBanniere, filteredData, praticiensData }) { 
  



  const exportToCSV = () => {
    let dataArray = (filteredData  && filteredData.length > 0) 
      ? filteredData
      : praticiensData;

    if (!dataArray || dataArray.length === 0) {
      alert("Aucune donnée à exporter !");
      return;
    }

    const firstItem = dataArray[0];
    if (!firstItem || typeof firstItem !== "object") {
      alert("Les données ne sont pas valides !");
      return;
    }

    const headers = Object.keys(firstItem);

    const csvRows = [
      headers.join(","), 
      ...dataArray.map(row =>
        headers.map(field => {
          let value = row[field];

          if (Array.isArray(value)) {
            value = JSON.stringify(value);
          }

          return JSON.stringify(value ?? ""); 
        }).join(",")
      )
    ];

    const csvContent = csvRows.join("\n");
    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "export.csv";
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className={`top-banner ${afficherBanniere ? "visible" : "hidden"}`}>
      <button style={{background:'transparent', border:"none", cursor:"pointer"}} onClick={() => window.open("https://toobib.org", "_blank")}>
        <img className="bandeau_image" src="LogoToobibBandeauHaut.png"/>
      </button>
      <button className="banner-button" onClick={() => window.open("https://toobib.org/cgu", "_blank")}>CGU</button>
      <button className="banner-button" onClick={() => window.open("https://toobib.org/mentions-legales", "_blank")}>Mentions légales</button>
      <button className="banner-button" onClick={() => window.open("https://toobib.org/politique-de-confidentialite", "_blank")}>Politique de confidentialité</button>
      <button className="banner-button" onClick={exportToCSV}>Exporter</button>
      <button className="banner-button" onClick={() => window.open("/documentation#historique", "_blank")}>Historique de modification</button>
      <button className="banner-button" onClick={() => window.open("/documentation#referentiels", "_blank")}>Réferentiels utilisés</button>
      <button className="banner-button" onClick={() => window.open("/documentation#faq", "_blank")}>FAQ</button>
    </div>
  );
}
